// @ts-nocheck
import React, { Component, memo } from 'react';
import { withTranslation } from 'react-i18next';

import { RootContext, StateContext } from '@/root/root.provider';
import { T } from '@/v2/helpers/i18n';

import './header.module.scss';
import { getHeaderBackgroundColor, getTextFontColor } from '@/v2/helpers/ticketColors/ticketColorsHelper.ts';
import { getBestDescription, TicketModel } from '@/v2/models/ticketModel.ts';
import { getLocatorCaptions } from '@/v2/helpers/additionalInfo/locatorCaptionsHelper.ts';
import { TicketTopSection, TicketTopSectionGeneric } from '@ticketmaster/global-design-system';

type Props = {
  ticket: TicketModel;
} & T;

class TicketHeader extends Component<Props, State> {
  static contextType: React.Context<StateContext> = RootContext;

  render() {
    const { ticket, t } = this.props;
    const headerBackgroundColor = getHeaderBackgroundColor(ticket);
    const textFontColor = getTextFontColor(ticket);
    const status = ticket.voidedAt ? 'disabled' : 'primary';
    const formatFieldValue = (value: object | string) => {
      if (!value) {
        return '-';
      }
      if (Array.isArray(value)) {
        return value.join('-');
      }
      return value;
    };

    const locatorCaptions = getLocatorCaptions(ticket);

    const formatGeneralAdmissionSubText = (ticket: TicketModel) => {
      if (ticket.showGARef) {
        return `${t('WALLET.TICKETS.TICKET.REF')}: ${formatFieldValue([ticket.section, ticket.row, ticket.seat])}`;
      } else {
        return formatFieldValue(ticket.section);
      }
    };

    const showInfo = () => {
      this.context.setActiveTicketId(ticket.id);
      this.context.setActiveProductId(null);
      this.context.setShowInfo(true);
    };

    return (
      <>
        {ticket.isGA ? <TicketTopSectionGeneric
          headerTitle={getBestDescription(ticket) || t('WALLET.TICKETS.DESCRIPTION')}
          mainText={t('WALLET.TICKETS.TICKET.GENERAL_ADMISSION')}
          subText={formatGeneralAdmissionSubText(ticket)}
          type={status}
          ticketInfoButtonData={{ callback: showInfo, accessibleDescription: 'Show info' }}
          {...(!!headerBackgroundColor && !!textFontColor) && {
            wayfindingColors: { background: headerBackgroundColor, foreground: textFontColor },
          }}
        /> : <TicketTopSection
          headerTitle={getBestDescription(ticket) || t('WALLET.TICKETS.DESCRIPTION')}
          row={{ title: locatorCaptions.row || t(`WALLET.TICKETS.TICKET.ROW`), value: formatFieldValue(ticket.row) }}
          seat={{ title: locatorCaptions.seat || t(`WALLET.TICKETS.TICKET.SEAT`), value: formatFieldValue(ticket.seat) }}
          section={{ title: locatorCaptions.section || t(`WALLET.TICKETS.TICKET.SECTION`), value: formatFieldValue(ticket.section) }}
          type={status}
          ticketInfoButtonData={{ callback: showInfo, accessibleDescription: 'Show info' }}
          {...(!!headerBackgroundColor && !!textFontColor) && {
            wayfindingColors: { background: headerBackgroundColor, foreground: textFontColor },
          }}
        />}
      </>
    );
  }
}

export default withTranslation('translation')(memo(TicketHeader));
